export const notificationSwal = {
  NOT_HAVE_ACCOUNT: "ยังไม่มีบัญชีผู้ใช้อยู่ในระบบ กรุณาสมัครสมาชิก",
};
